import {NgModule} from '@angular/core';
import {TypeaheadDirective} from './typeahead.directive';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ TypeaheadDirective ],
  exports: [ TypeaheadDirective ]
})
export class TypeaheadModule {}



// WEBPACK FOOTER //
// ./src/app/directives/typeahead/typeahead.module.ts